export interface LegendDataItem {
  /**
   * Text to be displayed for legend item.
   */
  legendText: string | number;

  /**
   * Color for the specific legend
   */
  legendColor: string;
}
